import styled, { css } from 'styled-components';

import { Button, Text as YogaText } from '@gympass/yoga';

import { WrapperProps } from './types';

export const Amount = styled(YogaText.H3)`
  color: ${({ theme }) => theme.yoga.colors.primaryLight};
`;

export const Text = styled(YogaText.Medium)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.light};
  color: ${({ theme }) => theme.yoga.colors.primaryLight};
`;

export const Wrapper = styled(Button)<WrapperProps>`
  ${({ theme, isActive }) => css`
    display: flex;
    flex-direction: column;
    height: 88px;
    border-radius: ${theme.yoga.radii.small}px;
    background-color: ${theme.yoga.colors.white};

    ${isActive &&
    css`
      background-color: ${theme.yoga.colors.primaryLight};

      ${Amount} {
        color: ${theme.yoga.colors.white};
      }

      ${Text} {
        color: ${theme.yoga.colors.white};
      }
    `}
  `}
`;
